export const SHOULD_GENERATE_ASSETS_KEY = 'make_shouldGenerateAssets';
